<template>
  <div id="app">
    <CcCountsCalendar />
  </div>
</template>

<script>
import CcCountsCalendar from './components/CcCountsCalendar.vue'

export default {
  name: 'app',
  components: {
    CcCountsCalendar
  }
}

</script>

<style>

</style>
